import { render } from "./Policy.vue?vue&type=template&id=054cdd02&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Policy.vue?vue&type=style&index=0&id=054cdd02&lang=scss&module=s"
cssModules["s"] = style0
import "./Policy.vue?vue&type=style&index=1&id=054cdd02&lang=scss&scoped=true"
import "./Policy.vue?vue&type=style&index=2&id=054cdd02&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-054cdd02"]])

export default __exports__